import { Phone, Clock } from "lucide-react";

export default function PhoneStrip() {
  return (
    <div
      data-testid="phone-strip"
      className="bg-green-600 text-white py-2.5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center gap-4 sm:gap-8 flex-wrap">
        <a
          href="tel:+491637917044"
          className="flex items-center gap-2 text-sm sm:text-base font-semibold hover:text-green-100 transition-colors active:scale-95"
          data-testid="phone-strip-call"
        >
          <Phone className="h-4 w-4" />
          <span>0163 791 7044</span>
        </a>
        <span className="hidden sm:inline text-green-200">|</span>
        <span className="flex items-center gap-2 text-xs sm:text-sm text-green-100">
          <Clock className="h-3.5 w-3.5" />
          Mo–Fr, 10:00–14:00 Uhr
        </span>
        <span className="hidden md:inline text-green-200">|</span>
        <span className="hidden md:inline text-xs sm:text-sm text-green-100">
          Auch Telefonberatung möglich
        </span>
      </div>
    </div>
  );
}
